import { IBooleanSelectOption } from '../interfaces/IBooleanSelectOption';

export const approvalBooleanSelectOptions: IBooleanSelectOption[] = [
  {
    id: 0,
    label: 'Удовлетворено',
    value: true,
  },
  {
    id: 1,
    label: 'Отказано',
    value: false,
  },
];
